import React, { Component } from 'react';
import ExamesProcedimentos from './ExamesProcedimentos';
import m from '@utils/strings';

class ExamesProcedimentosEletivos extends Component {
    
    render() {
        return (
            <ExamesProcedimentos 
                pageTitle={m.TELA_EXAMES_PROCEDIMENTOS.TITULO_TELA_EXAMES_PROCEDIMENTOS_ELETIVOS} 
                iconPath={"../images/procedimentos_lab.png"}
                tipoAtendimento={3}
            />
        );
    }
}

export default ExamesProcedimentosEletivos;